"use strict";
var PaymentFormData = (function () {
    function PaymentFormData() {
    }
    return PaymentFormData;
}());
exports.PaymentFormData = PaymentFormData;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/payments/payment-form-data.model.js